<template lang="html">
  <div class="full-page">
    <i-header title="投资者基本信息" @leftClick="$_headerLeftClick">
      <span slot="left"><i class="cubeic-back"></i></span>
    </i-header>
    <i-body>
      <cube-form
        :model="Model"
        class="form-custom"
        :options="options"
        @submit="$_handlerSubmit">
        <cube-form-group legend="基本信息">
            <cube-form-item :field="fields[0]"></cube-form-item>
            <cube-form-item :field="fields[1]">
              <div style="text-align:right;">
                {{$_iDCardTypesLabel(Model.catType)}}
              </div>
            </cube-form-item>
            <cube-form-item :field="fields[2]"></cube-form-item>
            <cube-form-item :field="fields[3]">
              <div @click.stop="$_handleShowOrgDocumentsValidityPicker" style="text-align:right;">
                <span
                  :style="{'color': Model.documentsValidity ? '#666' : '#ccc'}">
                  {{Model.documentsValidity || '请选择证件有效期'}}
                </span>
                <i class="cubeic-arrow"></i>
              </div>
            </cube-form-item>
            <cube-form-item :field="fields[4]"></cube-form-item>
          </cube-form-group>

          <cube-form-group legend="">
            <cube-form-item :field="fields[5]"></cube-form-item>
            <cube-form-item :field="fields[6]"></cube-form-item>
            <cube-form-item v-if="$_isForeign(Model.catType)" :field="fields[7]"></cube-form-item>
          </cube-form-group>

          <cube-form-group legend=" ">
            <cube-form-item :field="fields[8]"></cube-form-item>
            <cube-form-item v-if="Model.userOccupation === '自定义'" :field="fields[16]"></cube-form-item>
            <cube-form-item :field="fields[9]"></cube-form-item>
            <cube-form-item :field="fields[10]"></cube-form-item>
            <cube-form-item :field="fields[11]"></cube-form-item>
            <cube-form-item :field="fields[12]"></cube-form-item>
          </cube-form-group>

          <cube-form-group legend="">
            <cube-form-item :field="fields[13]"></cube-form-item>
            <cube-form-item :field="fields[14]"></cube-form-item>
          </cube-form-group>
          <cube-form-group legend="" class="submit-btn">
            <cube-button type="submit">下一步</cube-button>
          </cube-form-group>
      </cube-form>
    </i-body>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import mixin from '../config/addConfig';
import cmixin from '../../commonConfig';

export default {
  name: 'add-base-info',
  mixins: [mixin, cmixin],
  computed: {
    ...mapGetters(['managerInfo', 'au', 'naturalInfo']),
  },
  mounted() {
    setTimeout(() => {
      this.$bridge.callHandler('getBaseInfo', { msg: '获取投资者基本信息' }, (data) => {
        const obj = JSON.parse(data);
        console.log('新增', obj);
        this.$_handlerInit(obj.baseInfo);
        this.$_handlerInitData();
      });
    }, 300);
  },
  watch: {
    'Model.userOccupation': {
      handler(value) {
        if (value && !this.occupations.includes(value) && value !== '自定义') {
          this.Model.userOccupation = '自定义';
          this.Model.customUserOccupation = value;
        }
      },
    },
  },
  methods: {
    $_handlerInitData() {
      Object.keys(this.Model).forEach((key) => {
        if (this.naturalInfo[key]) {
          this.Model[key] = this.naturalInfo[key];
        }
      });
    },
    /**
     * 初始数据
     * @param  {[type]} data [description]
     * @return {[type]}      [description]
     */
    $_handlerInit(data) {
      const obj = JSON.parse(data);
      obj.catType = this.$_formatOldCatType(obj.catType);
      obj.userCountry = obj.userCountry || '中国'; // 默认 中国
      Object.keys(this.Model).forEach((key) => {
        this.Model[key] = obj[key];
      });
      this.$_getAgeAndSex(obj.idCardNo);
      if (obj.documentsValidity === '永久有效') {
        this.Model.isValidateForever = true;
      }
      this.$set(this.Model, 'documentsValidity', obj.documentsValidity);
    },
    /**
     * 下一步
     * @param  {[type]} e [description]
     * @return {[type]}   [description]
     */
    $_handlerSubmit(e) {
      e.preventDefault();
      const value = {
        ...this.Model,
        userOccupation: this.Model.userOccupation === '自定义' ? this.Model.customUserOccupation : this.Model.userOccupation,
      };
      this.$store.dispatch('changeNaturaInfo', value).then(() => {
        this.$router.push({
          path: '/natural/questions',
          query: {
            type: this.$route.query.type,
            draftsNo: this.draftsNo,
          },
        });
      });
    },
  },
};
</script>
